export default "__VITE_ASSET__da0306ed__"